import pure from "./higher-order/pure";
import React from "react";

export default pure(({ maxPicks, number }) => {
  var max = Math.ceil(maxPicks * 1.2);
  var pct = (number / max * 100.0).toFixed(2);
  return (
    <dl className="game-table_player-picks">
      <dt style={{width: pct + "%"}} />

      <dd data-player-picks={(number === 1 ? " player" : " players") + " picked this horse."} style={{left: pct + "%"}}>
        {number}
      </dd>
    </dl>
  );
});
